import {useRouteTemplates} from "hooks/useRouteTemplates";
import {useSetting} from "../../contexts/setting";
import cn from "classnames";
import TemplateControls from "../../layout/TemplateControls";
import SortableList from "../../layout/SortableList";
import HighlightShortcuts from "../../layout/HighlightShortcuts";
import "./index.css";

const GDN_TEXT_COLOR_SHORTCUTS = Object.freeze([
  {combination: "CMD+Shift+2", description: "change font color to brand color"},
  {combination: "CMD+Shift+0", description: "reset font color"},
]);

const Ads = () => {
  const {visible, currentVideoPopup, type} = useSetting();

  // The content type's banners, without the ones an admin removed
  // (libs/bannerComposition.ts).
  const items = useRouteTemplates("ads");
  const bannerIds = items.map((template) => template.id);
  const hasOnlyOneBanner = bannerIds.length === 1;

  return (
    <>
      {type.value === "google-display-network" ? (
        <HighlightShortcuts items={GDN_TEXT_COLOR_SHORTCUTS} />
      ) : null}
      <SortableList
        items={items}
        useDragHandle={true}
        getItemClassName={(item) =>
          cn("template-wrap", {
            hidden: !hasOnlyOneBanner && !visible.some((x) => x === item.id),
            popup: currentVideoPopup === item.id,
          })
        }
        renderItem={(item, {listeners, attributes} = {}) => (
          <>
            <div
              className="template-annotation"
              {...(listeners || {})}
              {...(attributes || {})}
              style={{cursor: "grab"}}
            >
              <span
                className="label"
                data-tooltip={item.tooltip || null}
              >{`${item.label} (${item.displayDimensions || item.dimensions}${item.suffix || ""})`}</span>
              <TemplateControls
                id={item.id}
                templateChannel="ads"
                hasOnlyOneBanner={hasOnlyOneBanner}
                bannerIds={bannerIds}
              />
            </div>
            {item.getComponent()}
          </>
        )}
      />
    </>
  );
};

export default Ads;
